// src/app/core/enums/dashboard.enum.ts

export enum DashboardPlatform {
  WEB = 'web',
  MOBILE = 'mobile'
}

export enum WidgetPlatform {
  WEB = 'web',
  MOBILE = 'mobile'
}

export enum DashboardType {
  PRODUCT_PAGE = 'product_page',
  MIXED = 'mixed'
}

export enum WidgetType {
  KPI = 'kpi',
  CHART = 'chart',
  TABLE = 'table',
  RANKING = 'ranking',
  MIXED = 'mixed'
}
